import { BrowserWindow } from "Types";

// testing for the presence of a browser window will come in handy for automated testing
const isInBrowser = typeof window !== "undefined";

export const getBrowserWindow = () =>
  isInBrowser ? (window as BrowserWindow) : undefined;
